<template>
  <div class="component-wrap" v-if="dataList && dataList.length">
    <div class="analysis-title-box">
      <h3 class="analysis-title">주 이용 디바이스</h3>
    </div>
    <ul class="my-major-device">
      <li v-for="(data, index) in dataList" :key="index">
        <img v-if="data.devicename === 'MOBILE'" src="@/assets/images/ico-my-phone.png">
        <img v-if="data.devicename === 'PC'" src="@/assets/images/ico-my-pc.png">
        <img v-if="data.devicename === 'TV'" src="@/assets/images/ico-my-tv.png">
        <p class="device-tit">{{data.devicename}}</p>
        <p class="device-text"><strong>{{data.viewtime}}</strong> 시간 이용</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    }
  },
  methods: {
    typeImage (type) {
      switch (type) {
        case 'MOBILE':
          return 'ico-my-phone'
        case 'PC':
          return 'ico-my-pc'
        case 'TV':
          return 'ico-my-tv'
        default:
          return 'ico-my-phone'
      }
    }
  }
}
</script>

<style lang="css">
.my-major-device{
  padding: 19px 0 20px;
}

.my-major-device:after{
  content: "";
  display: block;
  clear: both;
}

.my-major-device li{
  float: left;
  width: 33.3333%;
  text-align: center;
}

.my-major-device img{
  width: 100%;
  max-width: 66px;
  margin-bottom: 12px;
}

.device-tit{
  font-size: 14px;
  line-height: 20px;
  color: #a5a5a5;
}

.device-text{
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
}

.device-text > strong{
  color: #fff;
}
</style>
